import { Audience, ClaimStatus } from './CargoClaims.types';

/*
 * Clover runs six states of its own rather than mirroring AZADEA's nine, which
 * are their screen's lifecycle and would drag their internal workflow into ours.
 *
 * UNDER_REVIEW is the one state AZADEA has no equivalent for. It stays out of
 * the polling API, but AZADEA reads the same grid here, so it is labelled to say
 * who is holding the claim rather than appearing frozen.
 */
const LABELS: Record<ClaimStatus, string> = {
  RECEIVED: 'Received',
  DOCUMENTED: 'Documented',
  UNDER_REVIEW: 'In review',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  UNSETTLED: 'Unsettled',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled',
};

/*
 * The audience is optional, and absent means the plain label.
 *
 * It exists for one word: AZADEA has no state of their own matching
 * UNDER_REVIEW, so naming who holds the claim stops it reading as frozen. The
 * list does not pass it — who is looking has to come from the signed-in
 * profile rather than from a control on the page, and nothing wires that yet.
 */
export function statusLabel(status: ClaimStatus, audience?: Audience): string {
  if (status === 'UNDER_REVIEW' && audience === 'azadea') {
    return 'In review by Clover';
  }

  return LABELS[status];
}

export function statusColor(status: ClaimStatus): string {
  switch (status) {
    case 'ACCEPTED':
    case 'CLOSED':
      return 'success';
    case 'REJECTED':
    case 'CANCELLED':
      return 'danger';
    case 'UNSETTLED':
      return 'warning';
    default:
      return '';
  }
}

export const STATUS_OPTIONS = [
  { label: 'All', value: 'All' },
  ...(Object.keys(LABELS) as ClaimStatus[]).map((status) => ({
    label: LABELS[status],
    value: status,
  })),
];
